const RICH_TEXT_ROOT_SELECTOR = ".editor-text, .ck-editor__editable";

const priorityObservers = new WeakMap<Element, MutationObserver>();

function removeInlineStylePriority(element: HTMLElement): void {
  for (const propertyName of Array.from(element.style)) {
    if (element.style.getPropertyPriority(propertyName) === "important") {
      const propertyValue = element.style.getPropertyValue(propertyName);
      element.style.setProperty(propertyName, propertyValue);
    }
  }
}

function removeInlineStylePriorities(root: Element): void {
  for (const styledElement of root.querySelectorAll<HTMLElement>("[style]")) {
    removeInlineStylePriority(styledElement);
  }
}

function observeInlineStylePriorities(root: Element): void {
  removeInlineStylePriorities(root);
  if (priorityObservers.has(root)) {
    return;
  }

  const observer = new MutationObserver(() => {
    removeInlineStylePriorities(root);
  });
  observer.observe(root, {
    attributes: true,
    attributeFilter: ["style"],
    childList: true,
    subtree: true,
  });
  priorityObservers.set(root, observer);
}

/**
 * Remove inline CSS priority from rendered and editable rich text.
 *
 * Declaration values remain unchanged, so light-mode rendering stays faithful.
 * Without inline priority, dark-mode rules can override foreground and
 * background declarations together. The observer catches content inserted by
 * CKEditor's paste pipeline before the next paint and before server-side
 * sanitization runs.
 */
export function initializeInlineStylePriorityGuards(container: ParentNode): void {
  if (container instanceof Element && container.matches(RICH_TEXT_ROOT_SELECTOR)) {
    observeInlineStylePriorities(container);
  }
  for (const root of container.querySelectorAll(RICH_TEXT_ROOT_SELECTOR)) {
    observeInlineStylePriorities(root);
  }
}
